namespace Matrix.Rebalancer {
    export class ModellingViewColumnColumns {
        static columnsKey = 'Rebalancer.ModellingViewColumn';
    }
}
